module.exports = __webpack_public_path__ + "img/5c8c0d0.png";